"use client";

import { usePathname } from "next/navigation";
import { MessageSquare, Phone, PhoneCall, Send } from "lucide-react";
import Link from "next/link";
import { useAppSelector } from "@/_hooks/hooks";
import { ISettings } from "@/store/homeSlice";

export default function MobileStickyActions() {
  const pathname = usePathname();
  const SettingList = useAppSelector((state) => state.home.SettingList);

  if (pathname && (pathname.includes("/cart") || pathname.includes("/book"))) {
    return null;
  }

  const Settings: Record<string, string> = SettingList?.reduce(
    (acc, item: ISettings) => {
      acc[item?.SettingKey] = item?.SettingValue;
      return acc;
    },
    {} as Record<string, string>,
  );

  const PhoneNo = Settings?.["PhoneNo"];
  // const BookingLink = Settings?.["BookingLink"];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[999] md:hidden bg-white shadow-[0_-5px_15px_rgba(0,0,0,0.15)] flex items-stretch h-10">
      {/* Inquiry Button */}
      <Link
        href="/contact"
        className="flex-1 flex items-center justify-center gap-2 bg-[#15803d] text-white font-bold text-sm uppercase tracking-wider active:bg-green-800 transition-colors"
      >
        <MessageSquare className="w-4 h-4" />
        Inquiry
      </Link>

      <Link
        href={`tel:${PhoneNo}`}
        className="flex-1 flex items-center justify-center gap-2 bg-[#ea580c] text-white font-bold text-sm uppercase tracking-wider active:bg-orange-700 transition-colors"
      >
        <PhoneCall className="w-4 h-4 fill-white" />
        Call Us
      </Link>
    </div>
  );
}
